;(function($) {
	'use strict';
	
	var jq_throttle;
	
	$.fn.animateCss = function(options,removeClass) {

		//TODO: detect in and out

		const ANIMATION_PREFIX = 't3kk-animate';

		var animationClass,
			animationName,
			duration,
			isIn = false,
			isOut = false,
			remove = true;
	
		animationClass = ANIMATION_PREFIX;
	
		function whichAnimationStartEvent(){
			var t,
				el = document.createElement("fakeelementstart");

			var animations = {
				"transition"      : "animationstart",
				"OTransition"     : "oAnimationStart",
				"MozTransition"   : "animationstart",
				"WebkitTransition": "webkitAnimationStart"
			}

			for (t in animations){
				if (el.style[t] !== undefined){
					return animations[t];
				}
			}
		}
		var animationStartEvent = whichAnimationStartEvent();


		function whichAnimationEndEvent(){
			var t,
				el = document.createElement("fakeelementend");

			var animations = {
				"transition"      : "animationend",
				"OTransition"     : "oAnimationEnd",
				"MozTransition"   : "animationend",
				"WebkitTransition": "webkitAnimationEnd"
			}

			for (t in animations){
				if (el.style[t] !== undefined){
					return animations[t];
				}
			}
		}
		var animationEndEvent = whichAnimationEndEvent();
	
	
		if(typeof options === 'string') {
			animationName = options;
		} 
		else {
			animationName = options.name;
		}
	
	
	
		if(animationName.indexOf('-in') !== -1) {
			isIn = true;
		}
		if(animationName.indexOf('-out') !== -1) {
			isOut = true;
		}
	
	
	
	
		if(typeof options === 'string') {
			animationClass += ' '+ANIMATION_PREFIX+'--'+options;
			
			if(!(typeof removeClass === 'boolean')) {
				removeClass = false;
			}
			
			this.addClass(animationClass)
				.one(animationEndEvent, function(event) {
					if(removeClass === true) {
						$(this).removeClass(animationClass);
					}
					if(isIn || isOut) {
						var opacity = isIn ? 1 : 0;
						$(this).css({opacity:opacity});
					}
				});
		}
		else {
			
			if("name" in options) {
				animationClass += ' '+ANIMATION_PREFIX+'--'+animationName;
			}

			if(("duration" in options)) {
				duration = options.duration;
				animationClass += ' '+ANIMATION_PREFIX+'--'+duration;
			}

			if("remove" in options) {
				if(options.remove === false) {
					remove = false;
				}
			}

			this.addClass(animationClass)
				.one(animationStartEvent, function(event) {
					if("begin" in options) {
						if (typeof options.begin === 'function') options.begin();
					}
				})
				.one(animationEndEvent, function(event) {
					if(remove === true) {
						$(this).removeClass(animationClass);
					}
					if(isIn || isOut) {
						var opacity = isIn ? 1 : 0;
						$(this).css({opacity:opacity});
					}
					if("complete" in options) {
						if (typeof options.complete === 'function') options.complete();
					}
				});
			
		}

		return this;
		
	};
			
	$.fn.isOnScreen = function() {
		
		var win = $(window);

		var viewport = {
			top : win.scrollTop(),
			left : win.scrollLeft()
		};
		viewport.right = viewport.left + win.width();
		viewport.bottom = viewport.top + win.height();

		var bounds = this.offset();
		bounds.right = bounds.left + this.outerWidth();
		bounds.bottom = bounds.top + this.outerHeight();

		return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

	};
		
		
			
	$.fn.isScrolling = function() {
		console.log('is scrolling');
		var status = true;
		clearTimeout( $.data( this, "scrollCheck" ) );
		$.data( this, "scrollCheck", setTimeout(function() {
			status = false;
			return status;
		}, 250) );
	};

	$.fn.removeStyles = function() {
		$(this).attr('style','');
		return this;
	};

	$.fn.scrolled = function(func,detectEndOfScrolling) {
		if(typeof detectEndOfScrolling === 'undefined') {
			detectEndOfScrolling = false;
		}
			
		$(this).scroll(function() {

			function execute(func) {
				if(func != undefined && typeof func == 'function') {
					func();
				}
			};

			if(detectEndOfScrolling) {
				clearTimeout( $.data( this, "scrollCheck" ) );
				$.data( this, "scrollCheck", setTimeout(function() {
					execute(func);
				}, 250) );
			}
			else {
				execute(func);
			}
		});
	};

	$.fn.outerHTML = function() {
		return jQuery('<div />').append(this.eq(0).clone()).html();
	};
 
	
	
})(jQuery);